import { FC, ReactNode } from "react";

interface iWrapperRight {
  className?: string;
  children: ReactNode;
}
export const WrapperRight: FC<iWrapperRight> = (props) => {
  const className = `wrapper-right ${props.className ? props.className : ""}`;
  return <section className={className}>{props.children}</section>;
};
